import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-jeu-quatre-img',
  templateUrl: './create-jeu-quatre-img.component.html',
  styleUrls: ['./create-jeu-quatre-img.component.css']
})
export class CreateJeuQuatreImgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
